// 시리즈별 브랜드 매핑. 새 브랜드의 시리즈를 추가할 때만 여기에 항목을 추가하면 됨.
// (매핑에 없는 시리즈는 기본값 Matrix로 표시됨)
const OTHER_BRAND_SERIES = {
  Keystone: "Vision",
  Summit: "Vision",
  Access: "Vision",
};
const getSeriesBrand = (series) => OTHER_BRAND_SERIES[series] ?? "Matrix";

const FilterCard = ({ filters, setFilters, allItems, applyFilters }) => {
  // 고유 값들 추출
  const itemsOfCurrentType = allItems.filter(
    (item) => (item.itemType ?? "웨이트 기구") === filters.itemType,
  );
  // 시리즈에서 "-" 값은 제외하고 "전체"에만 뜨도록
  const seriesList = [...new Set(itemsOfCurrentType.map((item) => item.series))]
    .filter((series) => series && series !== "-")
    .sort((a, b) => {
      const aIsMatrix = getSeriesBrand(a) === "Matrix";
      const bIsMatrix = getSeriesBrand(b) === "Matrix";
      if (aIsMatrix === bIsMatrix) return 0; // 같은 그룹끼리는 원래 순서 유지
      return aIsMatrix ? -1 : 1;
    });
  const itemsForFormatList =
    filters.selectedSeries !== "전체"
      ? itemsOfCurrentType.filter((item) => item.series === filters.selectedSeries)
      : itemsOfCurrentType;
  const formatList = [...new Set(itemsForFormatList.map((item) => item.format))];

  return (
    <div
      style={{
        width: "24rem",
        flexShrink: 0,
        backgroundColor: "white",
        padding: "10px",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          applyFilters();
        }
      }}
    >
      <h3 style={{ marginTop: 0, fontSize: "20px" }}>검색 및 필터</h3>
      <div
        style={{
          display: "flex",
          gap: "8px",
          marginBottom: "12px",
        }}
      >
        {["웨이트 기구", "유산소 기구", "기타 기자재"].map((type) => {
          const selected = filters.itemType === type;
          return (
            <button
              key={type}
              type="button"
              onClick={() => {
                setFilters({
                  ...filters,
                  itemType: type,
                  selectedSeries: "전체",
                  selectedFormat: "전체",
                });
              }}
              style={{
                flex: 1,
                padding: "8px 12px",
                borderRadius: "8px",
                border: selected ? "2px solid #10134F" : "1px solid #ddd",
                background: selected ? "#eef0ff" : "#fff",
                fontWeight: selected ? 700 : 500,
                cursor: "pointer",
              }}
            >
              {type}
            </button>
          );
        })}
      </div>

      {/* 검색창 */}
      <div style={{ marginBottom: "12px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "8px",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          검색
        </label>
        <input
          type="text"
          placeholder="제품명 검색..."
          value={filters.searchText}
          onChange={(e) => setFilters({ ...filters, searchText: e.target.value })}
          style={{
            width: "100%",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            fontSize: "14px",
            boxSizing: "border-box",
          }}
        />
      </div>

      {/* 시리즈 필터 */}
      {filters.itemType !== "기타 기자재" && (
        <>
          <div style={{ marginBottom: "12px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              시리즈
            </label>
            <select
              value={filters.selectedSeries}
              onChange={(e) =>
                setFilters({ ...filters, selectedSeries: e.target.value, selectedFormat: "전체" })
              }
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                fontSize: "14px",
              }}
            >
              <option value="전체">전체</option>
              {seriesList.map((series) => (
                <option key={series} value={series}>
                  {series} ({getSeriesBrand(series)})
                </option>
              ))}
            </select>
          </div>

          {/* 양식 필터 */}
          <div style={{ marginBottom: "12px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              양식
            </label>
            <select
              value={filters.selectedFormat}
              onChange={(e) => setFilters({ ...filters, selectedFormat: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                fontSize: "14px",
              }}
            >
              <option value="전체">전체</option>
              {formatList.map((format) => (
                <option key={format} value={format}>
                  {format}
                </option>
              ))}
            </select>
          </div>
        </>
      )}

      {/* 초기화 버튼 */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          padding: "10px",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <button
          onClick={() =>
            setFilters({
              itemType: "웨이트 기구",
              searchText: "",
              selectedSeries: "전체",
              selectedFormat: "전체",
            })
          }
          style={{
            flex: 1,
            padding: "10px",
            backgroundColor: "#fff",
            color: "#10134F",
            border: "1px solid #10134F",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          필터 초기화
        </button>
        <button
          onClick={() => {
            applyFilters();
          }}
          style={{
            flex: 1,
            padding: "10px",
            backgroundColor: "#10134F",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          검색
        </button>
      </div>
    </div>
  );
};

export default FilterCard;
